export default "__VITE_ASSET__BiefuUq9__"